import apiService from "./apiService";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/user`;

export const getUserPreferenceService = async () => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_user_preferences`);
    return response.data;
  } catch (error) {
    console.error("Error getting user preferences:", error);
    throw error;
  }
};

export const updateUserPreferenceService = async (preferences) => {
  try {
    const response = await apiService.put(`${API_BASE_URL}/update_user_preferences`, { preferences });
    return response.data;
  } catch (error) {
    console.error("Error updating user preferences:", error);
    throw error;
  }
};

export const getEmailProcessingInstructionService = async () => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_email_processing_instructions`);
    return response.data;
  } catch (error) {
    console.error("Error getting email processing instructions:", error);
    throw error;
  }
};

export const getUserScheduleService = async () => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_user_schedule`);
    return response.data;
  } catch (error) {
    console.error("Error getting user schedule:", error);
    throw error;
  }
};

export const updateUserScheduleService = async (schedule) => {
  console.log("schedule", schedule);
  try {
    if (schedule.length === 0) {
      const response = await apiService.delete(`${API_BASE_URL}/clear_user_schedule`);
      return response.data;
    }
    const response = await apiService.put(`${API_BASE_URL}/update_user_schedule`, { schedule });
    return response.data;
  } catch (error) {
    console.error("Error updating user schedule:", error);
    throw error;
  }
};

export const getUserEmailActionReadOnlyService = async () => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_user_email_action_read_only`);
    return response.data;
  } catch (error) {
    console.error("Error getting user email action read only:", error);
    throw error;
  }
};

export const updateUserEmailActionReadOnlyService = async ({ enabled }) => {
  try {
    const response = await apiService.put(`${API_BASE_URL}/update_user_email_action_read_only`, { enabled });
    return response.data;
  } catch (error) {
    console.error("Error updating user email action read only:", error);
    throw error;
  }
};

export const updateUserScopeService = async (scope, action = "add") => {
  try {
    const response = await apiService.post(
      `${API_BASE_URL}/update_user_scopes`,
      { scope, action }
    );
    
    return response.data.updatedScopes || [];
  } catch (err) {
    console.error("[UserService] Error updating user scopes:", err);
    throw err;
  }
};

export const connectMicrosoftMailboxService = async (mailIntegrationId = null) => {
  try {
    const response = await apiService.post(
      `${API_BASE_URL}/connect_microsoft_mailbox`,
      mailIntegrationId ? { mailIntegrationId } : {},
    );
    return response.data;
  } catch (error) {
    console.error('[UserService] Error connecting Microsoft mailbox:', error);
    throw error;
  }
};

export const connectGoogleMailboxService = async (mailIntegrationId = null) => {
  try {
    const response = await apiService.post(
      `${API_BASE_URL}/connect_google_mailbox`,
      mailIntegrationId ? { mailIntegrationId } : {},
    );
    return response.data;
  } catch (error) {
    console.error('[UserService] Error connecting Google mailbox:', error);
    throw error;
  }
};

export const disconnectMailIntegrationService = async () => {
  try {
    const response = await apiService.delete(`${API_BASE_URL}/disconnect_mail_integration`);
    return response.data;
  } catch (error) {
    console.error('[UserService] Error disconnecting mail integration:', error);
    throw error;
  }
};

export const getMailIntegrationStatusService = async (provider, mailIntegrationId = null) => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/mail_integration_status`, {
      params: {
        provider,
        ...(mailIntegrationId ? { mailIntegrationId } : {}),
      },
    });
    return response.data;
  } catch (error) {
    console.error('[UserService] Error getting mail integration status:', error);
    throw error;
  }
};
